import { useState } from 'react';
import { FileText, Search, Pointer } from "lucide-react";
import { HeroBanner } from '@/components/sections/HeroBanner';

export default function ProcesoAdmision() {
  const [formData, setFormData] = useState({
    nombreEstudiante: '',
    fechaNacimiento: '',
    nombreApoderado: '',
    telefono1: '',
    telefono2: '',
    email: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    setStatus('sending');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: data,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setStatus('success');
        form.reset();
        setFormData({
          nombreEstudiante: '',
          fechaNacimiento: '',
          nombreApoderado: '',
          telefono1: '',
          telefono2: '',
          email: ''
        });
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <main className="flex-1 w-full flex flex-col items-center">
        <HeroBanner 
          title="Proceso de Admisión"
          subtitle="Conoce cómo postular a nuestra Escuela de Lenguaje Arcoíris para las matrículas 2027."
          backgroundImageUrl="/images/gallery/foto7.jpg"
        />
        <InformacionPostulacionSection />
        <PasosPostulacionSection />
        <FormularioPostulacionSection
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          status={status}
        />
      </main>
    </div>
  );
}

function InformacionPostulacionSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4 md:px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8 bg-white rounded-xl shadow-lg p-6 md:p-8">
          <div className="w-full md:w-1/4 flex justify-center">
            <div className="w-48 h-48 text-orange-500 bg-orange-50 p-6 rounded-full shadow-inner flex items-center justify-center">
              <FileText className="w-full h-full" />
            </div>
          </div>
          <div className="w-full md:w-3/4">
            <h2 className="text-3xl font-bold text-blue-800 mb-6 border-b-2 border-orange-300 pb-2 inline-block">
              ¿Cómo es la postulación a nuestra Escuela de Lenguaje?
            </h2>
            <p className="text-blue-700 text-lg leading-relaxed">
              Debe existir una evaluación previa por parte de la Fonoaudióloga de nuestra escuela, quien determinará si el estudiante presenta o no dificultades en el lenguaje. Luego, el apoderado deberá traer un documento llamado "Formulario Médico" que lo emite un Médico Pediatra o Neurólogo registrado en MINEDUC. Como último paso, se gestiona la matrícula para dar ingreso a nuestra gran Familia Arcoíris.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function PasosPostulacionSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4 md:px-4">
        <h2 className="text-3xl font-bold text-blue-800 mb-8 text-center">
          Pasos para la Postulación
          <div className="w-32 h-1 bg-blue-500 mx-auto mt-4"></div>
        </h2>
        <div className="max-w-6xl mx-auto">
          {/* Paso 1 */}
          <div className="flex flex-col md:flex-row items-center gap-8 mb-16 bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
            <div className="w-full md:w-1/4 bg-green-500 p-8 rounded-lg flex justify-center items-center transform hover:scale-105 transition-transform duration-300">
              <FileText className="w-24 h-24 text-white" />
            </div>
            <div className="w-full md:w-3/4">
              <h3 className="text-2xl font-bold text-green-600 mb-2">PASO 1:</h3>
              <h4 className="text-xl font-semibold text-green-600 mb-4 border-b-2 border-green-500 pb-2 inline-block">
                Formulario
              </h4>
              <p className="text-blue-700 leading-relaxed text-lg">
                Se debe completar el formulario con los datos del alumno(a) y apoderado(a), para ser contactado por parte de la escuela y agendar una cita para la evaluación Fonoaudiológica.
              </p>
            </div>
          </div>

          {/* Paso 2 */}
          <div className="flex flex-col md:flex-row items-center gap-8 mb-16 bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
            <div className="w-full md:w-1/4 bg-purple-600 p-8 rounded-lg flex justify-center items-center transform hover:scale-105 transition-transform duration-300">
              <Search className="w-24 h-24 text-white" />
            </div>
            <div className="w-full md:w-3/4">
              <h3 className="text-2xl font-bold text-purple-600 mb-2">PASO 2:</h3>
              <h4 className="text-xl font-semibold text-purple-600 mb-4 border-b-2 border-purple-500 pb-2 inline-block">
                Evaluación
              </h4>
              <p className="text-blue-700 leading-relaxed text-lg">
                Durante el Proceso de Evaluación, realizaremos una entrevista al alumno(a) con su apoderado(a) en nuestra Escuela. Luego de dicha entrevista, se concluye si el o la menor presenta dificultades en el lenguaje para posteriormente poder ser matriculado.
              </p>
            </div>
          </div>

          {/* Paso 3 */}
          <div className="flex flex-col md:flex-row items-center gap-8 bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
            <div className="w-full md:w-1/4 bg-blue-500 p-8 rounded-lg flex justify-center items-center transform hover:scale-105 transition-transform duration-300">
              <Pointer className="w-24 h-24 text-white" />
            </div>
            <div className="w-full md:w-3/4">
              <h3 className="text-2xl font-bold text-blue-600 mb-2">PASO 3:</h3>
              <h4 className="text-xl font-semibold text-blue-600 mb-4 border-b-2 border-blue-500 pb-2 inline-block">
                Matrícula
              </h4>
              <p className="text-blue-700 leading-relaxed text-lg">
                Al momento de gestionar la matrícula, el apoderado(a) deberá presentar el Formulario Único de Salud emitido por el Pediatra registrado en MINEDUC. Posterior a esto se procederá a completar los datos necesarios junto a nuestra secretaria, instancia en la que se entregará toda la información de utilidad para nuestros futuros alumnos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FormularioPostulacionSection({ formData, handleChange, handleSubmit, status }) {
  return (
    <section className="w-full py-12 md:py-16 bg-blue-50">
      <div className="container mx-auto px-4 md:px-4">
        <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-lg p-8">
          <h2 className="text-3xl font-bold text-blue-800 text-center mb-2">Postula</h2>
          <div className="w-32 h-1 bg-orange-500 mx-auto mb-8"></div>
          
          <p className="text-center text-blue-700 mb-8 text-lg">
            Completa la información del formulario a continuación y la secretaría de nuestra Escuela te contactará para agendar una pronta evaluación con la Fonoaudióloga.
          </p>
          
          <form
            action="https://formspree.io/f/xvgqggle"
            method="POST"
            onSubmit={handleSubmit}
            className="space-y-6 max-w-4xl mx-auto"
          >
            <div>
              <input
                type="text"
                name="nombreEstudiante"
                value={formData.nombreEstudiante}
                onChange={handleChange}
                placeholder="Nombre del estudiante"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                required
              />
            </div>
            
            <div>
              <input
                type="text"
                name="fechaNacimiento"
                value={formData.fechaNacimiento}
                onChange={handleChange}
                placeholder="Fecha de nacimiento (ej: DD/MM/AAAA)"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                required
              />
            </div>
            
            <div>
              <input
                type="text"
                name="nombreApoderado"
                value={formData.nombreApoderado}
                onChange={handleChange}
                placeholder="Nombre del apoderado"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                required
              />
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="tel"
                name="telefono1"
                value={formData.telefono1}
                onChange={handleChange}
                placeholder="Teléfono 1"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                required
              />
              
              <input
                type="tel"
                name="telefono2"
                value={formData.telefono2}
                onChange={handleChange}
                placeholder="Teléfono 2"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
              />
            </div>
            
            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                required
              />
            </div>
            
            <div className="text-center">
              {status === 'sending' && (
                <p className="text-blue-700">Enviando postulación...</p>
              )}
              {status === 'success' && (
                <p className="text-green-600 font-semibold">¡Postulación enviada con éxito! Nos pondremos en contacto contigo pronto.</p>
              )}
              {status === 'error' && (
                <p className="text-red-600">Hubo un error al enviar la postulación. Por favor, verifica los datos o intenta nuevamente.</p>
              )}
            </div>

            <div className="flex justify-center mt-6">
              <button
                type="submit"
                className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-12 rounded-full transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 disabled:opacity-50"
                disabled={status === 'sending' || status === 'success'}
              >
                {status === 'sending' ? 'Enviando...' : (status === 'success' ? 'Enviado' : 'Enviar Postulación')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
} 
